import styled from 'styled-components';

export const ListCard = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 24px;

    .application-name {
        font-size: 16px;
        color: #2B3A54;
    }

    .application-details {
        padding-top: 10px;
    }

    .application-description {
        font-size: 12px;
        color: #626E82;
    }

    .application-description-val {
        font-size: 12px;
        color: #626E82;
    }
`;

export const ButtonsCard = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const SaibaMaisButton = styled.a`
    color: #2B3A54;
    font-weight: bold;

    :hover {
        color: #2B3A54;
    }

    :active {
        color: #2B3A54;
    }
`;